import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator to check if a dates range is valid
 */
export class DateRangeValidator {
    static dateRange(startDateControlName: string, endDateControlName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const formGroup = control as FormGroup; // Cast to FormGroup

            if (!(formGroup instanceof FormGroup)) {
                return null; // Only apply to FormGroups
            }

            const startDateControl = formGroup.get(startDateControlName);
            const endDateControl = formGroup.get(endDateControlName);

            // Don't validate if either control is missing or empty
            if (!startDateControl || !endDateControl || !startDateControl.value || !endDateControl.value) {
                return null;
            }

            const startDate = new Date(startDateControl.value);
            const endDate = new Date(endDateControl.value);

            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                startDateControl.setErrors({ ...startDateControl.errors, invalidDate: true });
                endDateControl.setErrors({ ...endDateControl.errors, invalidDate: true });
                return { invalidDate: true };
            }

            if (startDate > endDate) {
                startDateControl.setErrors({ ...startDateControl.errors, dateRangeInvalid: true });
                endDateControl.setErrors({ ...endDateControl.errors, dateRangeInvalid: true });
                return { dateRangeInvalid: true };
            }

            // Validation passes
            const clearError = (control: AbstractControl, errorKey: string): void => {
                if (control.errors) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { [errorKey]: _, ...remainingErrors } = control.errors;
                    control.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
                }
            };

            // Remove just the error `dateRangeInvalid` if validation pass
            clearError(startDateControl, 'dateRangeInvalid');
            clearError(endDateControl, 'dateRangeInvalid');
            return null;
        };
    }
}
